<span
        class="badge rounded-pill"
        [ngClass]="{
        'badge-secondary': type == CompanyTypeEnum.NORMAL,
        'badge-success': type == CompanyTypeEnum.PREFERRED,
        'badge-warning': type == CompanyTypeEnum.PREFERRED_PLUS,
        'badge-danger': type == CompanyTypeEnum.DESIGNATE,
        }">{{text}}{{rate5 > Const.PLUS_RATE ? ' PLUS' : ''}}</span>
